import { render, staticRenderFns } from "./uploadOwnerToCrm.vue?vue&type=template&id=396b3528&scoped=true"
import script from "./uploadOwnerToCrm.vue?vue&type=script&lang=js"
export * from "./uploadOwnerToCrm.vue?vue&type=script&lang=js"
import style0 from "./uploadOwnerToCrm.vue?vue&type=style&index=0&id=396b3528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b3528",
  null
  
)

export default component.exports